import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setStatus('error');
      setMessage('Please enter a valid email address');
      return;
    }

    setStatus('loading');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d5f2qur07s2llnhdb91g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      if (response.ok) {
        setStatus('success');
        setMessage('Successfully subscribed! Check your inbox for confirmation.');
        setEmail('');
      } else {
        setStatus('error');
        setMessage('Something went wrong. Please try again.');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Network error. Please try again.');
    }
  };

  return (
    <section className="py-32 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="mb-16">
          <div className="relative h-96 rounded-3xl overflow-hidden mx-10">
            <img 
              src="https://public.readdy.ai/ai/img_res/28e3a41eaf68bb902ee9bc6ba9a160a5.jpg"
              alt="Newsletter"
              className="absolute inset-0 w-full h-full object-cover"
              style={{ filter: 'contrast(1.1) brightness(0.95)' }}
            />
          </div>
        </div>

        <div className="text-center mb-12">
          <p className="text-4xl font-bold text-gray-900 leading-relaxed max-w-4xl mx-auto">
            Get <span className="font-light italic text-gray-600">weekly tax updates</span> and <span className="font-light italic text-gray-600">exclusive insights</span> delivered straight to your inbox — completely <span className="font-bold">free</span>
          </p>
        </div>

        <form onSubmit={handleSubmit} className="max-w-2xl mx-auto mb-8" data-readdy-form>
          <div className="flex items-center bg-white border-2 border-gray-200 rounded-full overflow-hidden shadow-lg hover:border-teal-500 transition-colors">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="flex-1 px-8 py-4 text-lg focus:outline-none"
              disabled={status === 'loading'}
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-10 py-4 bg-black text-white font-semibold hover:bg-gray-800 transition-colors disabled:opacity-50 whitespace-nowrap"
            >
              {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
            </button>
          </div>
        </form>

        {status === 'success' && (
          <div className="text-center mb-6">
            <p className="text-green-600 font-medium">{message}</p>
          </div>
        )}

        {status === 'error' && (
          <div className="text-center mb-6">
            <p className="text-red-600 font-medium">{message}</p>
          </div>
        )}

        <p className="text-center text-sm text-gray-500 mb-8">
          Join 50,000+ subscribers. Unsubscribe anytime.
        </p>

        <div className="flex justify-center items-center gap-12">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-coral-100 rounded-full">
              <i className="ri-lock-line text-xl text-coral-600"></i>
            </div>
            <span className="text-sm text-gray-600 font-medium">Secure & Private</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-full">
              <i className="ri-mail-line text-xl text-teal-600"></i>
            </div>
            <span className="text-sm text-gray-600 font-medium">Weekly Delivery</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-full">
              <i className="ri-star-line text-xl text-amber-600"></i>
            </div>
            <span className="text-sm text-gray-600 font-medium">Expert Content</span>
          </div>
        </div>
      </div>
    </section>
  );
}